import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LockIcon from '@material-ui/icons/Lock';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '../../../../components/Typography';
import AddressForm from '../../subcomponents/SignUp/DetailsForm';
import PaymentForm from '../../subcomponents/SignUp/PaymentForm';
import VerifyPaymentModal from '../SignUp/VerifyPaymentModal';
import SwipeableViews from 'react-swipeable-views';
import { createMember, verifyAddress } from '../../../api/membership';
import {
  ftniAch,
  getContractSigningConfig,
  stripeCreditCard,
  stripeCallback
} from '../../../api/payment';
import { getPenguinsData } from '../../../../helpers';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import ContractSigning from '../SignUp/ContractSigning';
import {
  getCountry,
  getState,
  getSettlementAccount,
  PAYMENT_METHOD_CREDIT_CARD,
  PAYMENT_METHOD_ACH
} from '../SignUp/helpers';
import { loadExternalScript } from '../../../utils';

const styles = theme => ({
  modal: {
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      margin: '100px auto'
    },
    textAlign: 'center'
  },
  dialog: {
    [theme.breakpoints.up('md')]: {
      maxHeight: '80vh'
    }
  },
  header: {
    backgroundColor: theme.palette.secondary.dark,
    color: 'white',
    padding: '1rem 1rem'
  },
  backdropRoot: {
    backgroundColor: 'rgba(255,255,255,0.9)'
  },
  body: {
    width: '100%',
    padding: '0 2rem',
    [theme.breakpoints.down('401')]: {
      padding: '0 .5rem'
    },
    [theme.breakpoints.down('321')]: {
      padding: '0 .4rem'
    }
  },
  cardLogoRow: {
    maxWidth: '50%',
    margin: '10px auto'
  },
  submitRow: {
    margin: '1rem 3rem 0 3rem'
  },
  lastRow: {
    margin: '0.7rem 2rem 0.7rem 2rem',
    justifyContent: 'center !important',
    color: theme.palette.secondary.dark
  },
  cardInactive: {
    filter: 'grayscale(100%)'
  },
  closeIcon: {
    position: 'absolute',
    top: '1%',
    right: '1%',
    color: '#fff'
  },
  progressRow: {
    padding: 0
  },
  progressSpinner: {
    width: '1.5rem !important',
    height: '1.5rem !important',
    position: 'absolute',
    right: '1.5rem'
  }
});

const formStyles = theme => ({
  textField: {
    backgroundColor: theme.palette.secondary.light,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.875rem'
    },
    [theme.breakpoints.down('361')]: {
      fontSize: '13px'
    },
    [theme.breakpoints.down('321')]: {
      fontSize: '12px'
    }
  }
});

const StyledAddressForm = withStyles(formStyles, { withTheme: true })(
  AddressForm
);

const steps = [{ pos: 0, label: 'Details' }, { pos: 1, label: 'Payment' }];

function getCcBillingFromContact(contactInfo) {
  const country = getCountry(contactInfo.country);
  const stateAbbr = getState(country, contactInfo.state).abbr;
  return {
    NameOnCard: `${contactInfo.first_name} ${contactInfo.last_name}`,
    EmailAddress: contactInfo.email,
    Address1: contactInfo.street1,
    Address2: contactInfo.street2,
    City: contactInfo.city,
    State: stateAbbr,
    Zip: contactInfo.postal_code,
    Country: country.name
  };
}

function getAchBillingFromContact(contactInfo) {
  const country = getCountry(contactInfo.country);
  const stateAbbr = getState(country, contactInfo.state).abbr;
  return {
    NameOnAccount: `${contactInfo.first_name} ${contactInfo.last_name}`,
    Save: 'true',
    Amount: '0',
    EmailAddress: contactInfo.email,
    Address1: contactInfo.street1,
    Address2: contactInfo.street2,
    City: contactInfo.city,
    State: stateAbbr,
    Zip: contactInfo.postal_code,
    Country: country.name
  };
}

class CheckoutModal extends React.Component {
  constructor(props) {
    // check penguins_data in forpenguins.views.react_static.PricingView
    super(props);
    this.paymentRef = React.createRef();
    this.sessionKey = getPenguinsData(['view_data', 'session_key']);
    this.ftniCallBackUrl = getPenguinsData(['view_data', 'ftni_callback_url']);
    this.ftni_session_id = null;
    this.strategy = getPenguinsData(['view_data', 'strategy']);
    this.stripeCanKey = getPenguinsData([
      'view_data',
      'stripe_pk_can_membership'
    ]);
    this.stripeUsKey = getPenguinsData([
      'view_data',
      'stripe_pk_us_membership'
    ]);
    this.state = {
      selectedCard: null,
      activeStep: 0,
      payment: null,
      contactInfo: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        state: '',
        country: '',
        street1: '',
        street2: '',
        city: '',
        postal_code: ''
      },
      addressErrors: {
        street1: '',
        city: '',
        state: '',
        country: '',
        postal_code: ''
      },
      creditCardInfo: {
        Callback: this.ftniCallBackUrl,
        CardType: '1',
        CardNumber: '',
        Token: this.sessionKey,
        CVV: '',
        ExpirationMonth: '',
        ExpirationYear: '',
        Save: 'true',
        Amount: '0', // do not charge until contract is signed
        NameOnCard: '',
        EmailAddress: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Country: '',
        Settlement: 'US MEMON Card'
      },
      achInfo: {
        Callback: this.ftniCallBackUrl,
        AccountType: '', // 0=checking, 1=saving
        BankName: '',
        AccountNumber: '',
        ABANumber: '',
        NameOnAccount: '',
        Save: 'true',
        Amount: '0',
        EmailAddress: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Country: '',
        Settlement: 'US MEMON Check'
      },
      signingEmbedConfig: {},
      errorDialog: {
        error: '',
        display: '',
        visible: false
      },
      isProcessingContact: false,
      isProcessingPayment: false
    };
    this.submitContactForm = null;
    this.submitCreditCardForm = null;
    this.submitAchForm = null;
    this.paymentMethod = null; // to be set by PaymentForm
  }

  componentDidMount() {
    loadExternalScript({
      src: 'https://js.stripe.com/v2/'
    });
  }

  getProgressTab = (pos, constProps) => props =>
    pos <= this.state.activeStep ? (
      <Tab {...props} {...constProps} selected disabled={false} />
    ) : (
      <Tab {...props} {...constProps} />
    );

  handleStateResetAndClose = () => {
    this.setState(
      { creditCardInfo: {}, achInfo: {}, activeStep: 0 },
      this.props.handleClose
    );
  };

  handleErrorDialogVisibility = () =>
    this.setState(({ errorDialog }) => ({
      errorDialog: { ...errorDialog, visible: !errorDialog.visible }
    }));

  getHandleSubmitContactForm = handleSubmit => {
    if (handleSubmit) this.submitContactForm = handleSubmit;
  };

  getHandleSubmitCreditCardForm = handleSubmit => {
    if (handleSubmit) this.submitCreditCardForm = handleSubmit;
  };

  getHandleSubmitAchForm = handleSubmit => {
    if (handleSubmit) this.submitAchForm = handleSubmit;
  };

  setErrorDialog = ({ error, display }) => {
    this.setState({
      errorDialog: { error, display, visible: true },
      isProcessingContact: false
    });
  };

  onSubmitContactForm = (isValid, formData) => {
    if (isValid) {
      this.setState(
        prevState => ({
          hasContactInfoError: false,
          contactInfo: { ...prevState.contactInfo, ...formData },
          // formData overrides default, keeping tracking_id and type_id intact
          isProcessingContact: true
        }),
        () => {
          const country = getCountry(this.state.contactInfo.country);
          const state = getState(country, this.state.contactInfo.state);
          verifyAddress({
            ...this.state.contactInfo,
            country: country.name,
            state: state.name
          })
            .then(({ data }) => {
              const {
                success,
                street1,
                city,
                state,
                country,
                postal_code
              } = data;
              if (!success) {
                this.setState({
                  addressErrors: { street1, city, state, country, postal_code },
                  hasContactInfoError: true
                });
                return Promise.reject({
                  error: 'valiate_address: verification failed',
                  display:
                    'Address verification failed. Please enter your full billing address and try again.'
                });
              }
            })
            .then(() => {
              const { trackingId, typeId } = this.props;
              const data = Object.assign(
                {
                  tracking_id: trackingId,
                  type_id: typeId
                },
                this.state.contactInfo
              );
              return createMember(this.sessionKey, data);
            })
            .then(data => {
              this.ftni_session_id = data.ftni_session_id;
              this.setState(({ activeStep }) => ({
                activeStep: activeStep + 1,
                isProcessingContact: false,
                taxes: data.taxes
              }));
              this.paymentRef.current.scrollIntoView();
            })
            .catch(this.setErrorDialog);
        }
      );
    } else this.setState({ hasContactInfoError: true, contactInfo: {} });
  };

  onSubmitCreditCardForm = (isValid, formData) => {
    // have to make changes here
    // 1. tokenize credit card
    // return token to backend and create a charge for this
    // only capture the charge in the end when contract is signed
    //
    if (isValid) {
      this.setState(
        ({ creditCardInfo, contactInfo }) => {
          return {
            hasPaymentInfoError: false,
            creditCardInfo: {
              ...creditCardInfo,
              ...formData,
              ...getCcBillingFromContact(contactInfo),
              Settlement: getSettlementAccount(
                contactInfo.country,
                PAYMENT_METHOD_CREDIT_CARD
              ),
              Token: this.sessionKey
            },
            isProcessingPayment: true
          };
        },
        () => {
          const { creditCardInfo, contactInfo } = this.state;
          try {
            const [tokenizer, payload] = stripeCreditCard(
              contactInfo.country === '2'
                ? this.stripeCanKey
                : this.stripeUsKey,
              creditCardInfo
            );
            tokenizer(payload, (status, response) => {
              if (response.error) {
                throw new Error(response.error.message);
              }
              const body = {
                token: response.id,
                strategy: 'stripe',
                address: {
                  first_name: contactInfo.first_name,
                  last_name: contactInfo.last_name,
                  email: contactInfo.email,
                  phone: contactInfo.phone,
                  address_line1: contactInfo.street1,
                  address_line2: contactInfo.street2,
                  address_city: contactInfo.city,
                  address_state: contactInfo.state,
                  address_zip: contactInfo.postal_code,
                  address_country: contactInfo.country
                },
                billing: {
                  name: creditCardInfo.NameOnCard,
                  address_line1: creditCardInfo.Address1,
                  address_line2: creditCardInfo.Address2,
                  address_city: creditCardInfo.City,
                  address_state: creditCardInfo.State,
                  address_zip: creditCardInfo.Zip,
                  address_country: creditCardInfo.Country
                }
              };
              return stripeCallback(this.sessionKey, body);
            });
          } catch (e) {
            this.setState({
              hasPaymentInfoError: true,
              paymentInfo: {},
              isProcessingContact: false
            });
          }
        }
      );
    } else
      this.setState({
        hasPaymentInfoError: true,
        paymentInfo: {},
        isProcessingContact: false
      });
  };

  onSubmitAchForm = (isValid, formData) => {
    if (isValid) {
      this.setState(
        ({ achInfo, contactInfo }) => ({
          hasPaymentInfoError: false,
          achInfo: {
            ...achInfo,
            ...formData,
            ...getAchBillingFromContact(contactInfo),
            Settlement: getSettlementAccount(
              contactInfo.country,
              PAYMENT_METHOD_ACH
            ),
            Token: this.sessionKey
          },
          isProcessingPayment: true
        }),
        () => ftniAch(this.ftni_session_id, this.state.achInfo)
      );
    } else
      this.setState({
        hasPaymentInfoError: true,
        paymentInfo: {},
        isProcessingPayment: false
      });
  };

  setPaymentMethod = paymentMethod => {
    this.paymentMethod = paymentMethod; // PAYMENT_METHOD_CREDIT_CARD or PAYMENT_METHOD_ACH
    this.setState({ payment: paymentMethod });
  };

  goNext = () => {
    if (this.state.activeStep === 0) {
      // contact info step
      if (this.submitContactForm) {
        this.submitContactForm();
      }
    } else if (this.state.activeStep === 1) {
      // payment step
      if (
        this.paymentMethod === PAYMENT_METHOD_CREDIT_CARD &&
        this.submitCreditCardForm
      ) {
        this.submitCreditCardForm();
      } else if (
        this.paymentMethod === PAYMENT_METHOD_ACH &&
        this.submitAchForm
      ) {
        this.submitAchForm();
      }
    }
  };

  toggleStep = (event, value) => {
    this.setState({ activeStep: value });
  };

  changeStep = index => {
    if (index <= 1) this.setState({ activeStep: index });
  };

  onPaymentSuccess = data => {
    if (data.success) {
      getContractSigningConfig(this.sessionKey).then(({ data }) => {
        if (data && data.success) {
          // the get sign config call is relatively slow, so keep the payment loading spinner up until we can show
          // contract right away, so no gap in UX
          this.setState({ isProcessingPayment: false });
          this.handleStateResetAndClose(); // close the checkout modal
          const { debug, sign_url, client_id } = get(
            data,
            'signing_embed_config'
          );
          this.setState({ signingEmbedConfig: { debug, sign_url, client_id } });
        }
      });
    }
  };

  onContractSigningSuccess = () => {
    this.props.onSignUpSuccess(this.paymentMethod);
  };

  closeVerifyPayment = () => {
    this.setState({ isProcessingPayment: false });
  };

  render() {
    let {
      classes,
      theme,
      isOpen,
      initiationPrice,
      type,
      installmentPrice,
      fullScreen
    } = this.props;
    initiationPrice = parseFloat(initiationPrice);
    installmentPrice = parseFloat(installmentPrice);
    const totalDue = initiationPrice + installmentPrice;
    const [Step1, Step2] = steps.map(step =>
      this.getProgressTab(step.pos, { label: step.label })
    );
    const {
      hasContactInfoError,
      contactInfo: { country },
      contactInfo,
      activeStep,
      isProcessingContact,
      isProcessingPayment,
      addressErrors,
      taxes
    } = this.state;
    const currency = country === '2' ? '(CAD)' : '';
    const total = taxes ? (totalDue + +taxes).toFixed(2) : `${totalDue} + Tax`;
    const isCan = getCountry(contactInfo.country).name === 'CAN';
    return (
      <React.Fragment>
        <Dialog
          open={isOpen}
          fullScreen={fullScreen}
          className={classes.modal}
          classes={{ paper: classes.dialog }}
          onClose={this.handleStateResetAndClose}
          BackdropProps={{
            classes: {
              root: classes.backdropRoot
            }
          }}
        >
          <MuiDialogTitle className={classes.header}>
            <Hidden mdUp>
              <IconButton
                className={classes.closeIcon}
                aria-label="Close"
                onClick={this.handleStateResetAndClose}
              >
                <CloseIcon />
              </IconButton>
            </Hidden>
            <Typography
              variant="modalHeader"
              color="secondary.light"
              style={{ textTransform: 'capitalize' }}
            >
              {type} Membership <br /> ${total} {currency}
            </Typography>
          </MuiDialogTitle>
          <MuiDialogTitle className={classes.progressRow}>
            <Tabs
              value={this.state.activeStep}
              onChange={this.toggleStep}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Step1 />
              <Step2 disabled={hasContactInfoError || activeStep === 0} />
            </Tabs>
          </MuiDialogTitle>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.activeStep}
            onChangeIndex={this.changeStep}
            containerStyle={
              activeStep === 1 ? { height: '32rem' } : { height: '100%' }
            }
          >
            <MuiDialogContent className={classes.body}>
              <Typography color="secondary.dark">
                30-Day Money Back Guarantee
              </Typography>
              <StyledAddressForm
                triggerSubmit={this.getHandleSubmitContactForm}
                onSubmit={this.onSubmitContactForm}
                addressErrors={addressErrors}
              />
            </MuiDialogContent>
            <MuiDialogContent className={classes.body}>
              <div ref={this.paymentRef}>
                {this.state.payment === PAYMENT_METHOD_CREDIT_CARD && (
                  <div style={{ marginBottom: '8px' }}>
                    <img src={'/static/images/visa.svg'} alt="" />
                    <img src={'/static/images/mastercard.svg'} alt="" />
                    {!isCan && <img src={'/static/images/amex.svg'} alt="" />}
                    {!isCan && (
                      <img src={'/static/images/discover.svg'} alt="" />
                    )}
                  </div>
                )}
                <Typography color="secondary.dark">
                  30-Day Money Back Guarantee
                </Typography>
                <PaymentForm
                  ftniSessionId={this.ftni_session_id}
                  onSubmitCreditCard={this.onSubmitCreditCardForm}
                  onSubmitAch={this.onSubmitAchForm}
                  contactInfo={contactInfo}
                  getCreditCardSubmit={this.getHandleSubmitCreditCardForm}
                  getAchSubmit={this.getHandleSubmitAchForm}
                  setPaymentMethod={this.setPaymentMethod}
                  countryName={getCountry(contactInfo.country).name}
                  type={type}
                />
                {isProcessingPayment && (
                  <VerifyPaymentModal
                    onSuccess={this.onPaymentSuccess}
                    paymentMethod={this.paymentMethod}
                    sessionKey={this.sessionKey}
                    handleClose={this.closeVerifyPayment}
                  />
                )}
              </div>
            </MuiDialogContent>
          </SwipeableViews>
          <MuiDialogActions className={classes.submitRow}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              disabled={isProcessingContact || isProcessingPayment}
              onClick={this.goNext}
            >
              {this.state.activeStep > 0 ? 'COMPLETE ORDER' : 'NEXT STEP'}
              {isProcessingContact && (
                <CircularProgress
                  className={classes.progressSpinner}
                  color="secondary"
                />
              )}
            </Button>
          </MuiDialogActions>
          <MuiDialogActions className={classes.lastRow}>
            <LockIcon style={{ height: '0.6em' }} />
            <Typography variant="finePrint"> SECURED WITH SSL</Typography>
          </MuiDialogActions>
        </Dialog>
        <Dialog
          open={this.state.errorDialog.visible}
          onClose={this.handleErrorDialogVisibility}
        >
          <MuiDialogTitle>Errors</MuiDialogTitle>
          <MuiDialogContent>
            <DialogContentText>
              {this.state.errorDialog.display}
            </DialogContentText>
          </MuiDialogContent>
          <MuiDialogActions>
            <Button
              onClick={this.handleErrorDialogVisibility}
              color="primary"
              variant="contained"
              autoFocus
            >
              Dismiss
            </Button>
          </MuiDialogActions>
        </Dialog>
        <ContractSigning
          signingEmbedConfig={this.state.signingEmbedConfig}
          onSuccess={this.onContractSigningSuccess}
        />
      </React.Fragment>
    );
  }
}

CheckoutModal.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  initiationPrice: PropTypes.string.isRequired,
  installmentPrice: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool,
  typeId: PropTypes.string.isRequired,
  trackingId: PropTypes.string.isRequired,
  onSignUpSuccess: PropTypes.func.isRequired,
  theme: PropTypes.object
};

export default withMobileDialog()(
  withStyles(styles, { withTheme: true })(CheckoutModal)
);
